import React from 'react';
import { reduxForm, Field, FormSection } from 'redux-form';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import get from 'lodash/get';
import 'react-widgets/dist/css/react-widgets.css';
import TextField from '../../../FormElements/TextField';
import validation from '../../../../tools/validation';
import CategoriesCheckboxField from '../../../FormElements/CategoriesCheckboxField';
import DetailFiltersCheckboxField from '../../../FormElements/DetailFiltersCheckboxField';
import RenderItemFields from './RenderItemFields';
import ProductCodes from '../../../FormElements/ProductCodes';
import { baseModuleScreens } from '../../../../constants';
import i18n from '../../../../internationalization/i18n';
import MultiselectTagsField from '../../../FormElements/MultiselectTagsField';
import CheckboxField from '../../../FormElements/CheckboxField';

const textInputValidationRules = [validation.required, validation.maxLength(255)];

const propTypes = {
  currentModule: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  selectable: PropTypes.array.isRequired,
  productTypes: PropTypes.array,
  detailFilters: PropTypes.array,
  changeScreen: PropTypes.func,
  allTags: PropTypes.array,
  enabledModules: PropTypes.array.isRequired,
};

const defaultProps = {
  productTypes: [],
  detailFilters: [],
  changeScreen: () => {},
  allTags: [],
  route: {},
};

const renderPublishedWarning = (currentModule) => {
  const isPublished = get(currentModule, 'list_page_route.published', false);

  if (isPublished) {
    return null;
  }

  return (
    <div className="c-bb-form__input-warning">
      {i18n.t('CONTENT.baseModuleNotPublished')}
    </div>
  );
};

const BaseModuleItemForm = ({
  handleSubmit,
  submitting,
  changeScreen,
  currentModule,
  selectable,
  productTypes,
  detailFilters,
  allTags,
  enabledModules,
}) => (
  <form className="c-bb-form__container" onSubmit={handleSubmit}>
    <div className="c-bb-form__input-wrap c-bb-form__input-wrap--publish">
      <Field
        name="route.published"
        component={CheckboxField}
        label={i18n.t('CONTENT.publish').toUpperCase()}
      />
    </div>
    {renderPublishedWarning(currentModule)}
    <div className="c-bb-form__input-wrap">
      <Field
        name="title"
        component={TextField}
        label={i18n.t('BASE_MODULE.title')}
        validate={textInputValidationRules}
      />
    </div>
    <RenderItemFields fields={currentModule.fields} />
    {/* @todo extract to components nsi poduct types */}
    {!!productTypes.length &&
    <div>
      <div className="c-bb-form__input-item-group" style={{ marginBottom: '20px' }}>
        <div className="input-item-group__label">TYPE</div>
        <div className="input-item-group">
          {productTypes.map(type => (
            <label key={`${type.id}_${type.label}`} htmlFor={`${type.id}_${type.label}`} style={{ marginRight: '20px' }}>
              <Field
                id={`${type.id}_${type.label}`}
                name="type"
                component="input"
                type="radio"
                value={type.id.toString()}
              />
              &nbsp;&nbsp;
              {type.label}
            </label>
          ))}
        </div>
      </div>
    </div>}
    {!!selectable.length &&
    <Field
      name="categories"
      categories={selectable}
      label={i18n.t('CONTENT.category')}
      component={CategoriesCheckboxField}
      // validate={categoriesValidationRules}
    />}
    {enabledModules.includes('base_module_tags') && <Field
      name="tags"
      component={MultiselectTagsField}
      label={i18n.t('CONTENT.tags')}
      data={allTags}
    />}
    {!!detailFilters.length &&
    <div className="c-bb-form__input-item-group" style={{ marginBottom: '20px' }}>
      <div className="input-item-group__label">DETAIL FILTERS</div>
      <FormSection name="detailFilters" style={{ display: 'flex', padding: '15px', paddingTop: '45px', flexWrap: 'wrap' }}>
        {detailFilters.map((filter, i) => (
          /* eslint-disable */
          <Field
            key={`${filter.label}_${i}`}
            name={filter.label}
            categories={filter.filters}
            label={filter.label}
            component={DetailFiltersCheckboxField}
          />
        ))}
      </FormSection>
    </div>}
    {!!detailFilters.length &&
    <div className="c-bb-form__input-item-group" style={{ marginBottom: '20px' }}>
      <div className="input-item-group__label">PRODUCT CODES</div>
      <FormSection name="productCodes">
        <ProductCodes />
      </FormSection>
    </div>
    }
    <div className="c-bb-form__footer c-bb-form__actions c-bb-form__actions--fixed">
      <button
        className="c-bb-form__submit c-bb-button--primary c-bb-button"
        type="submit"
        disabled={submitting}
      >
        {i18n.t('CONTENT.save').toUpperCase()}
      </button>
      <button
        className="c-bb-form__reset c-bb-button--secondary c-bb-button"
        type="button"
        onClick={() => changeScreen(baseModuleScreens.moduleItemsList)}
      >
        {i18n.t('CONTENT.reset').toUpperCase()}
      </button>
    </div>
  </form>
);

BaseModuleItemForm.propTypes = propTypes;
BaseModuleItemForm.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  const {
    global: {
      websiteSettings: {
        enabledModules,
      },
    },
  } = state;

  return {
    enabledModules,
  };
};

export default reduxForm({
  form: 'baseModuleItemForm',
  enableReinitialize: true
})(
  withNamespaces()(connect(mapStateToProps, null)(BaseModuleItemForm)),
);



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleItems/BaseModuleItemEdit/BaseModuleItemForm.js